export enum QuoteToolInitParametersEnum {
  Locale = 'locale',
  Company = 'company',
}
